export default __webpack_public_path__ + "static/media/P7.1426b566.png";